<template>
    <div class="py-4 container-fluid">
        <div class=" row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <h6>Historial de pagos</h6>
                    </div>
                    <div class="card-body px-0 pt-0 pb-2">
                        <div class="table-responsive p-0">

                            <table class="table align-items-center mb-0">
                                <thead>
                                    <tr>
                                        <th
                                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Observación</th>
                                        <th
                                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Total pagado</th>
                                        <th
                                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Fecha</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="value in data" :key="value.id">
                                        <td class="align-middle text-sm">
                                            <h6 class="mb-0 text-sm">{{ value.observation }}</h6>
                                        </td>
                                        <td class="align-middle text-center text-sm">
                                            <h6 class="mb-0 text-sm">{{
                                                parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</h6>
                                        </td>
                                        <td class="align-middle text-center text-sm">
                                            <h6 class="mb-0 text-sm">{{ isValidDate(value.created_at) ? new
                                                Date(value.created_at).toLocaleDateString('es-ES') : 'Sin asignar' }}
                                            </h6>
                                        </td>
                                    </tr>

                                    <tr v-if="data.length === 0">
                                        <td colspan="5" class="text-center text-xxs">No hay registros disponibles</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="pagination p-3">
                                <!-- Recorremos los links para generar los botones -->
                                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer"
                                    @click="fetchData(link.url)" :disabled="!link.url || link.active"
                                    :class="{ 'active': link.label === currentPage.toString() }">
                                    {{ link.label }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ProjectsList',
    props: ['userId'],
    computed: {
        ...mapGetters('productionPayments', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
        currentPage() {
            return this.$store.state.productionPayments.currentPage; // Obtiene la pagina actual
        },
        lastPage() {
            return this.$store.state.productionPayments.lastPage; // Obtiene la última página
        },
        data() {
            return this.allData; // Retorna los usuarios desde el store
        },
        links() {
            return this.$store.getters['productionPayments/links']; // Retorna los links
        },
    },
    methods: {
        async fetchData(pageUrl = null) {
            const params = {
                user_id: this.userId,
                page: pageUrl,
            };
            await this.$store.dispatch('productionPayments/fetchData', params);
        },
        isValidDate(date) {
            if (!date) {
                return false;
            }
            const parsedDate = new Date(date);
            return !isNaN(parsedDate.getTime());
        },
    },
    mounted() {
        this.fetchData(); // Llama a fetchUsers cuando el componente se monta
    },
};
</script>

<style scoped>
.pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.page-item {
    margin: 0 5px;
}

.active {
    font-weight: bold;
    /* Estilo para la página activa */
}
</style>